import React from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { withRouter } from 'react-router-dom'
import loadable from '../../../loadable'

const routes = [
  {
    path: '/book/airport-transfer',
    exact: true,
    component: loadable(() => import('../../../../pages/App/B2CPages'), {
      bookingType: 'transfer',
    }),
    type: 'register',
  },
  {
    path: '/book/chauffeur',
    exact: true,
    component: loadable(() => import('../../../../pages/App/B2CPages'), {
      bookingType: 'chauffeur',
    }),
    type: 'register',
  },
]

const AuthRoutes = () => {
  return (
    <Switch>
      {routes.map(route => {
        const { path, component } = route
        return <Route key={path} path={path} component={component} />
      })}
      <Redirect from={'/book'} to={'/auth/login'} />
    </Switch>
  )
}

export default withRouter(AuthRoutes)

export { routes }
